<template>
    <div
        v-click-outside="focus_out_global"
        :class="{
            'form-group': true,
            'has-input': focus || value,
            'is-focused': show_hint,
            required: required,
            'has-icon': !!icon_class,
            unit: !!unit,
            disabled: disabled,
            'timepicker-container': !!timepicker,
            'has-error': invalid,
            'reset-visible': !!show_reset,
            active: has_clicked
        }"
    >
        <div class="placeholder show">
            <label :for="name">{{ label }}</label>
            <span v-if="required" class="star">*</span>
        </div>
        <v-date-picker
            :available-dates="!!available_dates"
            transition="none"
            v-if="datepicker"
            style="width: 100%;"
            class="absolute"
            :theme="{
                dayContentDisabled: {
                    light: 'disabled-date'
                }
            }"
            :disabled-dates="!!disabledDates"
            :min-date="min_date"
            :max-date="max_date"
            :attributes="calendar_attributes"
            :hidePopover="hide_pop"
            @input="event_date_picked"
            popover-align="center"
            :value="selected_date"
            @popoverDidShow="clicked"
            @popoverDidHide="pop_hide"
            :popover="{ placement: 'bottom', visibility: 'click', delay: 0, positionFixed: true }"
        >
            <input
                v-if="!format"
                :readonly="readonly"
                class="form-input  datepicker-input"
                :value="value | formatDate"
            />
            <input
                v-else
                :readonly="readonly"
                class="form-input  datepicker-input"
                :value="value | formatDate((full_year = true))"
            />
        </v-date-picker>

        <vue-timepicker
            @open="clicked"
            :minute-interval="15"
            name="timepicker-inp"
            ref="time-picker"
            :value="selected_time"
            close-on-complete
            @change="time_picked"
            @close="pop_hide"
            placeholder=" "
            input-class="form-input datepicker-input time-inp"
            v-if="timepicker"
            format="HH:mm"
        >
        </vue-timepicker>

        <input
            :maxLength="limit"
            @blur="focus_out"
            @focus="on_focus"
            :autofocus="!!autofocus"
            v-if="!datepicker && !timepicker"
            :value="value"
            :min="min"
            oninput="javascript: if (this.maxLength && this.maxLength > 0 && this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            :type="input_type"
            @keydown="validateInput($event)"
            @keyup="update_self($event)"
            @paste="validatePastedInput($event)"
            autocomplete="off"
            @keydown.enter="on_enter($event.target.value)"
            :class="{ 'form-input': true, selectized: !!autosuggest }"
            :id="name"
        />

        <span class="form-unit" v-if="unit">
            {{ unit }}
        </span>
        <span v-show="name !== 'password'" v-if="icon_class" :class="icon_class"></span>
        <span @click="reset" v-if="show_reset && value" class="icon icon-reset" style=""></span>

        <span @click="toggle_psw_visibility" v-if="name === 'password'" v-show="icon_class" :class="icon_class"></span>

        <div v-if="error_msg" class="form-error">{{ error_msg }}</div>
        <div v-if="focus && hint" class="hint">{{ hint }}</div>

        <div class="results" v-if="searchResults && searchResults.length > 0">
            <a @click="resultClicked(s)" v-for="s in searchResults" href="javascript:{}" class="result-item"
                >{{ s.first_name }} <span style="margin-left: .3rem;" v-if="s.last_name">{{ s.last_name }}</span>
                <div style="margin-left: .3rem;" v-if="s.parents && s.parents.length > 0">
                    <span style="margin-right: .3rem;font-weight:300;" v-for="p in s.parents">({{ p.full_name }})</span>
                </div>
            </a>
        </div>
    </div>
</template>
<script>
import datePicker from "v-calendar";
import VueTimepicker from "vue2-timepicker";
import { mapMutations, mapState } from "vuex";
import vClickOutside from "v-click-outside";
import axios from "axios";
import debounce from "lodash/debounce";
import settings from "@/settings";

window._ = require("lodash");

import Vue from "vue";

export default {
    name: "custom-input",
    props: [
        "value",
        "disabled",
        "autosuggest",
        "required",
        "error_msg",
        "label",
        "min",
        "format",
        "show_reset",
        "hint",
        "capitalize",
        "name_capitalization",
        "name",
        "limit",
        "autofocus",
        "icon_class",
        "input_type",
        "invalid",
        "allow_input",
        "datepicker",
        "unit",
        "timepicker"
    ],
    components: {
        datePicker,
        VueTimepicker
    },

    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        let readonly = true;
        if (this.allow_input) {
            readonly = true;
        }
        let attrs = [
            {
                key: "today",
                highlight: {
                    backgroundColor: "#ff8080"
                },
                class: "today-highlight",
                dates: new Date()
            }
        ];
        let min_date = null;
        let max_date = new Date();

        let disabled_dates = {
            end: this.get_yesterday() //disable all dates before today
        };
        let available_dates = { start: new Date(), end: null };
        if (!this.allow_input) {
            min_date = new Date();
            max_date = null;
            disabled_dates = null;
            available_dates = null;
        }

        return {
            readonly: readonly,
            searchResults: [],
            calendar_attributes: attrs,
            show_hint: false,
            hide_pop: false,
            max_date: max_date,
            min_date: min_date,
            available_dates: available_dates,
            disabledDates: disabled_dates,
            date: null,
            displayTime: "00:00",
            has_clicked: false,
            focus: false
        };
    },

    computed: {
        ...mapState("StorePeople", ["person"]),
        ...mapState("StoreEvent", ["errors"]),
        selected_date() {
            if (this.value) {
                return new Date(this.value);
            } else {
                return null;
            }
        },
        selected_time() {
            if (this.value) {
                return this.value;
            } else {
                return {
                    HH: " ",
                    mm: " "
                };
            }
        }
    },

    mounted() {},
    methods: {
        ...mapMutations("StoreEvent", ["set_errors"]),
        get_yesterday() {
            const d = new Date();
            d.setDate(d.getDate() - 1);
            return d;
        },
        capialize_inp(text) {
            return text.charAt(0).toUpperCase() + text.substring(1);
        },
        convert_date(str) {
            if (str) {
                var date = new Date(str),
                    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                    day = ("0" + date.getDate()).slice(-2);
                return [date.getFullYear(), mnth, day].join("-");
            } else {
                return null;
            }
        },
        resultClicked(r) {
            this.$emit("autosuggest", r);
            this.searchResults = [];
        },
        on_focus() {
            if (this.hint) {
                this.show_hint = true;
                this.remove_from_errors();
            }
            this.focus = true;
        },
        focus_out($evt) {
            if (this.autosuggest) {
                return;
            }
            if (this.hint) {
                this.show_hint = false;
            }
            if (!this.value) {
                this.focus = false;
            }
        },
        focus_out_global() {
            if (this.autosuggest) {
                this.searchResults = [];
                this.focus = false;
            }
            if (this.hint) {
                this.show_hint = false;
            }
            if (!this.value) {
                this.focus = false;
            }
        },
        isNumberEntered($event) {
            let keyCode = $event.which ? $event.which : $event.keyCode;
            let cmd_held = $event.metaKey;
            let ctrl_held = $event.ctrlKey;
            let shift_held = $event.shiftKey;
            if (shift_held) return false;
            if (
                (keyCode >= 48 && keyCode <= 57) ||
                (keyCode >= 96 && keyCode <= 105) ||
                keyCode === 46 ||
                keyCode === 8 ||
                ((cmd_held || ctrl_held) && [65, 67, 86].includes(keyCode))
            ) {
                return true;
            }
            return false;
        },
        pop_hide(e) {
            this.focus_out();
            this.has_clicked = false;
        },
        clicked() {
            this.focus = true;
            this.has_clicked = true;
        },
        event_date_picked(e) {
            if (e) {
                this.hide_pop = true;
                this.focus = true;
                this.date = this.convert_date(e);
                this.remove_from_errors();
                this.$emit("change", {
                    prop_name: this.name,
                    prop_value: this.date
                });
            } else {
                this.focus = false;
            }
        },
        time_picked(e) {
            this.focus = true;
            if (e.displayTime.length > 0) {
                if (e.data.HH && e.data.mm) {
                    this.remove_from_errors();
                    this.$emit("change", {
                        prop_name: this.name,
                        prop_value: e.displayTime
                    });
                } else {
                    this.errors.push("time");
                    this.$emit("change", {
                        prop_name: this.name,
                        prop_value: e.displayTime
                    });
                }
            } else {
                this.focus = false;
                this.$emit("change", {
                    prop_name: this.name,
                    prop_value: null
                });
            }
        },
        toggle_psw_visibility() {
            let x = document.getElementById("password");
            if (x.type === "password") {
                x.type = "text";
            } else {
                x.type = "password";
            }
        },
        remove_from_errors() {
            if (this.errors && this.errors.length > 0) {
                let errors = this.errors.filter((value, index, arr) => {
                    return value !== this.name;
                });
                this.set_errors(errors);
            }
        },
        validateInput($event) {
            if (this.name === "budget") {
                if (!this.isNumberEntered($event)) {
                    $event.preventDefault();
                    return false;
                }
            }
            if (this.input_type === "phone_basic") {
                if (!this.isNumberEntered($event)) {
                    $event.preventDefault();
                    return false;
                }
            }
            if (this.name === "phone" && this.input_type !== "phone_basic") {
                if (!this.isPhoneEntered($event)) {
                    $event.preventDefault();
                    return false;
                }
            }
        },
        getSuggestions: _.debounce(function() {
            this.searchResults = [];
            if (this.value) {
                let url = settings.api_url + "/autosuggest?term=" + encodeURIComponent(this.value);
                if (this.person.id) {
                    url =
                        settings.api_url +
                        "/autosuggest?term=" +
                        encodeURIComponent(this.value) +
                        "&person_id=" +
                        this.person.id;
                }
                axios.get(url).then(responseObj => {
                    if (responseObj.data.results && responseObj.data.results.length > 0) {
                        let item_ids = [];
                        if (this.person.kids && this.person.kids.length > 0) {
                            this.person.kids.forEach(k => {
                                if (k.id) {
                                    item_ids.push(k.id);
                                }
                            });
                        }
                        this.searchResults = responseObj.data.results.filter(item => !item_ids.includes(item.temp_id));

                        this.focus = true;
                    } else {
                    }
                });
            }
        }, 400),
        validatePastedInput($event) {
            let value = $event.clipboardData.getData("Text").trim();
            if (this.name === "budget") {
                if (!/^[0-9]*$/.test(value)) {
                    $event.preventDefault();
                    return false;
                }
            }
            if (this.input_type === "phone_basic") {
                console.log("validate");
                if (!/^[0-9]*$/.test(value)) {
                    $event.preventDefault();
                    return false;
                }
            }
            if (this.name === "phone" && this.input_type !== "phone_basic") {
                if (!/^(?=.*[0-9])[+0-9]+$/.test(value)) {
                    $event.preventDefault();
                    return false;
                }
            }
            return true;
        },
        capitalize_name(input) {
            input = input === undefined || input === null ? "" : input;
            input = input.toLowerCase();
            return input.toString().replace(/(^|[\ ?,\-] *)([a-zõäöü])/g, function(match, separator, char) {
                return separator + char.toUpperCase();
            });
        },
        isPhoneEntered($event) {
            let keyCode = $event.which ? $event.which : $event.keyCode;
            let cmd_held = $event.metaKey;
            let ctrl_held = $event.ctrlKey;
            if (
                (keyCode >= 48 && keyCode <= 57) ||
                (keyCode >= 96 && keyCode <= 105) ||
                keyCode === 46 ||
                keyCode === 187 ||
                keyCode === 107 ||
                keyCode === 8 ||
                ((cmd_held || ctrl_held) && [65, 67, 86].includes(keyCode))
            ) {
                return true;
            }
            return false;
        },

        update_self($event) {
            let value = $event.target.value.replace(/^\s+/, "");
            if (this.name === "budget") {
                value = value.replace(/^0+/, "");
            }
            if (this.input_type === "phone_basic") {
                value = value.replace(/^0+/, "");
            }
            if (this.capitalize) {
                value = this.capialize_inp(value);
            }
            if (this.name_capitalization) {
                value = this.capitalize_name(value);
            }
            this.remove_from_errors();
            if (this.autosuggest) {
                this.getSuggestions();
            }
            this.$emit("change", { prop_name: this.name, prop_value: value });
        },
        reset() {
            this.$emit("change", { prop_name: this.name, prop_value: null });
        },
        on_enter(name) {
            this.$emit("enter", name);
        }
    }
};
</script>

<style scoped>
.datepicker-input {
    cursor: pointer;
}

.form-group.has-input.reset-visible.has-icon span.icon-calendar {
    display: none;
}

.icon-calendar {
    pointer-events: none;
}

.results {
    z-index: 1000;
    position: absolute;
    display: flex;
    flex-direction: column;
    max-height: 20rem;
    overflow: auto;
    background: white;
    top: 5.5rem;
    width: 99.4%;
    border: 0.2rem solid #00a8b3;
    box-shadow: 0 0 0.8rem rgba(0, 168, 178, 0.5);
    border-radius: 0.4rem;
    margin-left: -0.1rem;
}

.results .result-item:first-child:before {
    content: "";
    height: 0.7rem;
    width: 100%;
    position: absolute;
    top: -0.7rem;
    background: inherit;
    z-index: 2;
    left: 0rem;
}

.result-item {
    margin: 1rem 0;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    padding: 1rem 1.2rem;
    letter-spacing: 0.03em;
    color: #000000;
    font-style: normal;
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 2rem;
    text-decoration: none;
    white-space: nowrap;
    text-overflow: ellipsis;
    flex-wrap: wrap;
}

.result-item span,
.result-item div {
    pointer-events: none;
}
</style>
